<template>
  <navBack></navBack>
  <view class="sign-list">
    <t-checkbox-group v-model="signs" :options="shopSigns" @change="onChange" />

        <div class="confirmBar">
      <t-button theme="primary" size="large" @click="saveSign" >
      保存
      </t-button>
    </div>
 
  </view>
</template>

<script setup>
import { ref, getCurrentInstance ,onMounted} from 'vue'
import { Toast } from 'tdesign-mobile-vue'
import navBack  from '@/components/nav-back.vue'
const { proxy } = getCurrentInstance();
import { stateCustomer,stateReloadCustomer,stateShop } from '@/store';
import { updateField } from '@/utils';
const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase
// 响应式数据
const signs = ref([])

const shopSigns = ref([])

 
// 复选框变更事件
const onChange = (value) => {
  signs.value = value
  console.log('选中的标签:', value)
}
// 保存标签
const saveSign = async  () => {
 
  let signs=signs.value;
  const _id=stateCustomer._id;
  
   await  updateField(app,_id,"my_customer",{signs});
     stateReloadCustomer.value = true
  Toast.success('保存成功')
}

// 初始化数据
const loadShopSign = async  () => {
  // 示例数据
  let shopId = stateShop._id;
  const db = app.database();
  await db.collection('my_customer_signs')
    .where({ shopId, deleted: 0 })
    .orderBy('createdAt', 'desc')
    .get()
    .then(res => {

      let shopSigns = res.data.map(item => ({
        label: item.name,
        valuupdateFielde: item._id
      }));
      shopSigns.value = shopSigns;
    })
}

onMounted(() => {
loadShopSign()
})
// 初始化数据

</script>

<style scoped>
.sign-list {
  padding: 20px;
  
  min-height: 100vh;
}

.smallBtn {
  color: #007aff;
  font-size: 28px;
  margin-right: 20px;
}
.confirmBar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20vw;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 -1px 34px rgba(0, 0, 0, 0.1);
  z-index: 999;
}
</style>